var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    {
      attrs: {
        title:
          _vm.$t("suppliers.kyc_form._label") +
          " - " +
          _vm.currentSupplier.SocialReason,
      },
    },
    [
      _c("template", { slot: "pageContent" }, [
        _c(
          "div",
          { staticClass: "specialContainer" },
          [
            _c(
              "b-row",
              { staticClass: "mb-3" },
              [
                _c(
                  "b-col",
                  { staticClass: "p-0", attrs: { cols: "2" } },
                  [_c("back-button")],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c(
                  "vue-tabs",
                  {
                    attrs: {
                      "active-tab-color": "#F9FBFC",
                      "active-text-color": "var(--actionButtonColorBlue)",
                    },
                    model: {
                      value: _vm.tabName,
                      callback: function ($$v) {
                        _vm.tabName = $$v
                      },
                      expression: "tabName",
                    },
                  },
                  [
                    _vm._l(_vm.workflow.steps, function (step, indexStep) {
                      return _c(
                        "v-tab",
                        { key: indexStep, attrs: { title: step.step_label } },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "title" }, slot: "title" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "suppliers.kyc_form." +
                                        step.step_label +
                                        "._label"
                                    )
                                  ) +
                                  "  \n              "
                              ),
                              step.status === 101
                                ? _c("i", {
                                    staticClass: "fa-solid fa-circle-small",
                                    style:
                                      "color:" +
                                      _vm.getStatusColor(step.status),
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              step.status === 102
                                ? _c("i", {
                                    staticClass: "fa-solid fa-circle-small",
                                    style:
                                      "color:" +
                                      _vm.getStatusColor(step.status),
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              step.status === 103
                                ? _c("i", {
                                    staticClass: "fa-solid fa-circle-small",
                                    style:
                                      "color:" +
                                      _vm.getStatusColor(step.status),
                                  })
                                : step.status === 104
                                ? _c("i", {
                                    staticClass: "fa-solid fa-check",
                                    style:
                                      "color:" +
                                      _vm.getStatusColor(step.status),
                                  })
                                : step.status === 105
                                ? _c("i", {
                                    staticClass: "fa-solid fa-xmark",
                                    style:
                                      "color:" +
                                      _vm.getStatusColor(step.status),
                                  })
                                : step.status === 106
                                ? _c("i", {
                                    staticClass: "fa-solid fa-xmark",
                                    style:
                                      "color:" +
                                      _vm.getStatusColor(step.status),
                                  })
                                : _vm._e(),
                            ]
                          ),
                          _vm._v(" "),
                          _c("supplier-kyc-form-step", {
                            staticStyle: { "margin-top": "30px" },
                            attrs: { step: step, seller: _vm.currentSupplier },
                          }),
                        ],
                        1
                      )
                    }),
                    _vm._v(" "),
                    _vm.display
                      ? _c(
                          "v-tab",
                          { attrs: { title: _vm.$t("suppliers.infos") } },
                          [
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  { attrs: { cols: "12" } },
                                  [
                                    _vm.DataList
                                      ? _c("table", { staticClass: "table" }, [
                                          _c("thead", [
                                            _c(
                                              "th",
                                              { attrs: { width: "170" } },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("common.title"))
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "th",
                                              { attrs: { width: "130" } },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("common.date_label")
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "th",
                                              { attrs: { width: "550" } },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "common.comment_label"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "th",
                                              { attrs: { width: "150" } },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("common.actions")
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "tbody",
                                            _vm._l(
                                              _vm.DataList,
                                              function (result) {
                                                return _c("tr", [
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(result.title)
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        result.creation_date
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _vm._v(_vm._s(result.note)),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-center",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "fileClickButton mr-4 cursor",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.editNote(
                                                                result.id_kyc_custom_data
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "common.edit_label"
                                                                )
                                                              ) +
                                                              "\n                      "
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "fileClickButton cursor",
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.deleteNote(
                                                                result.id_kyc_custom_data
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "common.del_label"
                                                                )
                                                              ) +
                                                              "\n                      "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ])
                                              }
                                            ),
                                            0
                                          ),
                                        ])
                                      : _c(
                                          "b-row",
                                          {
                                            staticClass:
                                              "justify-content-center",
                                          },
                                          [
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("common.no_comment")
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                    _vm._v(" "),
                                    _c(
                                      "b-row",
                                      [
                                        _c(
                                          "b-col",
                                          {
                                            attrs: { cols: "2", offset: "10" },
                                          },
                                          [
                                            _c(
                                              "b-button",
                                              {
                                                attrs: {
                                                  variant: "primary",
                                                  size: "lg",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.addNote()
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fa-light fa-plus",
                                                }),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "suppliers.add_note"
                                                      )
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  2
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }